import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface CommonHeadingProps {
  heading: string;  // The heading text
  sx?: SxProps<Theme>;  // Optional sx prop to customize the styling
  
}

const CommonHeading: React.FC<CommonHeadingProps> = ({ heading, sx }) => {
  return (
    <Box 
      color="#3B3B3B" 
      role="heading" 
      sx={{
        fontWeight: '600',  // Correct font weight usage
        fontSize: { xs: '1rem', md: '22px' },
        ...sx,  // Allow user to pass additional styles through sx
      }} 
    >
      {heading}
    </Box>
  );
};

export default CommonHeading;
